// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';
import { meetingTypes } from '../../../models/StockholderMeeting';

export default class TypeSelectView extends JQueryView {
  constructor() {
    super('.simple_form');
    $('#new_officer_approval_stockholder_meeting_type_select_form').on(
      'submit',
      function() {
        // みなし開催の同意を得られていない場合はモーダルを閉じない
        if (
          $(
            '#officer_approval_stockholder_meeting_type_select_form_type_10',
          ).prop('checked') ||
          $(
            '#officer_approval_stockholder_meeting_type_select_form_agreement',
          ).prop('checked')
        ) {
          $('#meetingTypeForm').modal('hide');
        }
      },
    );
    this.render();
  }

  @on({
    event: 'change',
    selector:
      'input[name="officer_approval_stockholder_meeting_type_select_form[type]"]',
  })
  onChangeTypeSelect() {
    this.render();
  }

  render() {
    // 実開催とかみなし開催の説明の文言は初期は見えないようにしている。
    $('#actually_sentence').hide();
    $('#written_sentence').hide();

    const meetingType = parseInt(
      $(
        'input[name="officer_approval_stockholder_meeting_type_select_form[type]"]',
      )
        .filter(':checked')
        .val(),
    );
    if (meetingType === meetingTypes.ACTUALLY) {
      $('#actually_sentence').show();
    } else if (meetingType === meetingTypes.WRITTEN) {
      $('#written_sentence').show();
    }
  }
}
